import React, { FC } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { WithColor } from '@styles/colors/types';
import {scale} from '@components/frame';
import { DASHBOARD_SUMMARY_CARD_CONFIG } from '@v2/pages/dashboard/common/components/DashboardSummary/constants';
import {font} from '@styles/fonts';

interface CardProps extends WithColor {
  label: string;
  valueText: string;
  valueColor: string;
  testID?: string;
  fullWidth?: boolean;
}

const Card: FC<CardProps> = ({ C, label, valueText, valueColor, testID, fullWidth }) => (
  <View
    testID={testID}
    style={{
      flex: fullWidth ? undefined : 1,
      width: fullWidth ? '100%' : undefined,
      height: scale(DASHBOARD_SUMMARY_CARD_CONFIG.height),
      borderRadius: scale(DASHBOARD_SUMMARY_CARD_CONFIG.radius),
      overflow: 'hidden',
      alignItems: 'center',
      justifyContent: 'center',
      gap: scale(DASHBOARD_SUMMARY_CARD_CONFIG.innerGap),
    }}
  >
    <View style={[StyleSheet.absoluteFillObject, { backgroundColor: valueColor, opacity: DASHBOARD_SUMMARY_CARD_CONFIG.opacity }]} />
    <Text style={[font['Caption 2'], { color: C('Label/Light/Tertiary') }]}>{label}</Text>
    <Text style={[font['Subhead 1 bold'], { color: valueColor }]}>{valueText}</Text>
  </View>
);

export default Card;
